import { InvitesActionTypes } from './actionTypes';
import type {
  DeleteInviteFailed,
  DeleteInviteRequest,
  DeleteInviteSucceeded,
  LoadInvitesFailed,
  LoadInvitesRequest,
  LoadInvitesSucceeded,
  SendInvitesFailed,
  SendInvitesRequest,
  SendInvitesSucceeded,
} from './actions';

import type { Invite, InviteForm, SendInviteError } from '@cobliteam/common-types';

export const loadInvitesRequest = (): LoadInvitesRequest => ({
  type: InvitesActionTypes.LOAD_INVITES_REQUEST,
});

export const loadInvitesRequestSucceeded = (pendingInvites: Invite[]): LoadInvitesSucceeded => ({
  type: InvitesActionTypes.LOAD_INVITES_SUCCEEDED,
  payload: pendingInvites,
});

export const loadInvitesRequestFailed = (): LoadInvitesFailed => ({
  type: InvitesActionTypes.LOAD_INVITES_FAILED,
});

export const sendInvitesRequest = (invites: InviteForm[]): SendInvitesRequest => ({
  type: InvitesActionTypes.SEND_INVITES_REQUEST,
  payload: invites,
});

export const sendInvitesRequestSucceeded = (): SendInvitesSucceeded => ({
  type: InvitesActionTypes.SEND_INVITES_SUCCEEDED,
});

export const sendInvitesRequestFailed = (payload?: SendInviteError): SendInvitesFailed => ({
  type: InvitesActionTypes.SEND_INVITES_FAILED,
  payload,
});

export const deleteInviteRequest = (invite: Invite): DeleteInviteRequest => ({
  type: InvitesActionTypes.DELETE_INVITE_REQUEST,
  payload: invite,
});

export const deleteInviteRequestSucceeded = (): DeleteInviteSucceeded => ({
  type: InvitesActionTypes.DELETE_INVITE_SUCCEEDED,
});

export const deleteInviteRequestFailed = (): DeleteInviteFailed => ({
  type: InvitesActionTypes.DELETE_INVITE_FAILED,
});
